import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import ActionCreators from "../../store/actions";
import moment from "moment";
import { CALENDAR_TYPES } from "../../store/helpers/constantVariables";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    paddingBottom: theme.spacing(1),
    alignItems: "center",
    justifyContent: "flex-start"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: 140
  },
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1) * 2
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  arrowsContainer: {
    display: "flex",
    flexDirection: "column"
  },
  arrow: {
    cursor: "pointer"
  }
});

const PeriodComponent = props => {
  const onStartDateChangeHandler = event => {
    const startDate = moment(event.target.value);
    const { periodEndDate } = props;
    const daysCount = periodEndDate.diff(startDate, "days", true);

    props.setPeriodDataHandle({
      periodStartDate: startDate,
      periodEndDate: periodEndDate,
      periodDaysCount: daysCount
    });

    props.onSetCalendarType(CALENDAR_TYPES.PERIOD);
  };

  const onEndDateChangeHandler = event => {
    const endDate = moment(event.target.value);
    const { periodStartDate } = props;
    const daysCount = endDate.diff(periodStartDate, "days", true);

    props.setPeriodDataHandle({
      periodStartDate: periodStartDate,
      periodEndDate: endDate,
      periodDaysCount: daysCount + 1
    });

    props.onSetCalendarType(CALENDAR_TYPES.PERIOD);
  };

  const { classes, calendarType, periodStartDate, periodEndDate } = props;

  return (
    <>
      <TextField
        type="date"
        id="start-date"
        onChange={onStartDateChangeHandler.bind(this)}
        value={periodStartDate.format("YYYY-MM-DD")}
        label="Wynajem od"
        className={classes.textField}
      />
      <TextField
        type="date"
        id="end-date"
        value={periodEndDate.format("YYYY-MM-DD")}
        onChange={onEndDateChangeHandler.bind(this)}
        label="Wynajem Do"
        className={classes.textField}
      />
    </>
  );
};

const mapStateToProps = state => {
  return {
    periodStartDate: state.formReducer.periodStartDate,
    periodDaysCount: state.formReducer.periodDaysCount,
    periodEndDate: state.formReducer.periodEndDate,
    calendarType: state.formReducer.calendarType
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPeriodDataHandle: value =>
      dispatch({ type: "SET_PERIOD_DATA", value: value }),
    onSetCalendarType: value =>
      dispatch({ type: "SET_CALENDAR_TYPE", calendarType: value })
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PeriodComponent)
);
